import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  frame: 0,
  initTime: '',
  isLoading: true,
  isMetric: true,
  isPlaying: false,
  layersArr: [],
  spanHours: 19,
}

export const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setNewMapState: (state, action) => {
      return { ...state, ...action.payload }
    },
    increment: (state) => {
      if (state.frame < state.spanHours - 1) {
        state.frame += 1;
      } else {
        state.frame = 0;
      }
    },
    decrement: (state) => {
      if (state.frame > 0) {
        state.frame -= 1;
      } else {
        state.frame = state.spanHours - 1;
      }
    }
  },
})

// Action creators are generated for each case reducer function
export const { setNewMapState, increment, decrement } = mapSlice.actions

export default mapSlice.reducer